module.exports = __webpack_public_path__ + "img/edit.ecf11303.svg";